import { Component, inject } from '@angular/core';
import { PermissionsService } from '../../../core/services/permissions.service';

@Component({
  selector: 'app-permission-gate',
  templateUrl: './permission-gate.html',
  styleUrl: './permission-gate.scss'
})
export class PermissionGate {
  private readonly permissions = inject(PermissionsService);

  readonly notificationStatus = this.permissions.notificationStatus;
  readonly locationStatus = this.permissions.locationStatus;
  readonly notificationOk = this.permissions.notificationOk;
  readonly locationOk = this.permissions.locationOk;

  allowNotifications(): void {
    this.permissions.requestNotification();
  }

  allowLocation(): void {
    this.permissions.requestLocation();
  }
}
